'use strict';

var NewExtractSelectFieldsSubpanelDirective = function NewExtractSelectFieldsSubpanelDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/new-extract-select-fields-subpanel.html'),
    requires: '^rmDataExtractNewExtract'
  };
};
NewExtractSelectFieldsSubpanelDirective.$inject = [];
module.exports = NewExtractSelectFieldsSubpanelDirective;